import type { Operator } from 'react-querybuilder';
import { DataConditionOperator } from 'src/graphql/entities/behavior/behavior-config/behavior-config.types';

/** The operators a support-policy condition supports; the shared evaluator maps them to set membership. */
export const SUPPORT_POLICY_CONDITION_OPERATORS: Operator[] = [
  { name: DataConditionOperator.In, label: 'In' },
  { name: DataConditionOperator.NotIn, label: 'Not in' },
];

/**
 * Date and date-time properties compare against a single date instead of a set. `Equals` reads as
 * "On" because the shared evaluator compares calendar days in the partner timezone for it — an
 * exact-timestamp equality would never match a date the user picked.
 */
export const SUPPORT_POLICY_DATE_CONDITION_OPERATORS: Operator[] = [
  { name: DataConditionOperator.Equals, label: 'On' },
  { name: DataConditionOperator.Before, label: 'Before' },
  { name: DataConditionOperator.After, label: 'After' },
];
